import React from "react";
export interface UseCaseIconProps {
    strokeColor: string;
    usecase: string;
}
export const UseCaseIcon: React.FC<UseCaseIconProps> = ({ strokeColor, usecase }) => {
    switch (usecase) {
        case "Appointment & rescheduling":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        d="M6 18H42M18 30L22 34L30 26M14 6V10M34 6V10M12.4 42H35.6C37.8402 42 38.9604 42 39.816 41.564C40.5686 41.1806 41.1806 40.5686 41.564 39.816C42 38.9604 42 37.8402 42 35.6V16.4C42 14.1598 42 13.0397 41.564 12.184C41.1806 11.4314 40.5686 10.8195 39.816 10.436C38.9604 10 37.8402 10 35.6 10H12.4C10.1598 10 9.03968 10 8.18404 10.436C7.43138 10.8195 6.81946 11.4314 6.43598 12.184C6 13.0397 6 14.1598 6 16.4V35.6C6 37.8402 6 38.9604 6.43598 39.816C6.81946 40.5686 7.43138 41.1806 8.18404 41.564C9.03968 42 10.1598 42 12.4 42Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "Lead qualification":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        d="M6 18H42M18 30L22 34L30 26M14 6V10M34 6V10M12.4 42H35.6C37.8402 42 38.9604 42 39.816 41.564C40.5686 41.1806 41.1806 40.5686 41.564 39.816C42 38.9604 42 37.8402 42 35.6V16.4C42 14.1598 42 13.0397 41.564 12.184C41.1806 11.4314 40.5686 10.8195 39.816 10.436C38.9604 10 37.8402 10 35.6 10H12.4C10.1598 10 9.03968 10 8.18404 10.436C7.43138 10.8195 6.81946 11.4314 6.43598 12.184C6 13.0397 6 14.1598 6 16.4V35.6C6 37.8402 6 38.9604 6.43598 39.816C6.81946 40.5686 7.43138 41.1806 8.18404 41.564C9.03968 42 10.1598 42 12.4 42Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "Broadcast & bulk messaging":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                    <path
                        d="M8 14.6504C8 10.8792 8 8.99353 9.17158 7.82197C10.3431 6.65039 12.2288 6.65039 16 6.65039H32C35.7712 6.65039 37.6568 6.65039 38.8284 7.82197C40 8.99353 40 10.8792 40 14.6504V30.6504C40 36.3072 40 39.1356 38.2426 40.893C36.4852 42.6504 33.6568 42.6504 28 42.6504H20C14.3431 42.6504 11.5147 42.6504 9.75736 40.893C8 39.1356 8 36.3072 8 30.6504V14.6504Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                    <path d="M30 36.6504V42.6504M18 36.6504V42.6504" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path d="M18 16.6504H30" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path d="M18 24.6504H30" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                </svg>
            );
        case "Lead nurturing":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                    <path
                        d="M30.75 23.1504C34.4779 23.1504 37.5 20.1283 37.5 16.4004C37.5 12.6725 34.4779 9.65039 30.75 9.65039C27.0221 9.65039 24 12.6725 24 16.4004C24 20.1283 27.0221 23.1504 30.75 23.1504Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                    <path
                        d="M44.8508 25.4004C44.5508 24.9504 44.1008 24.6504 43.5008 24.6504C40.2008 24.6504 37.0508 26.1504 35.1008 28.8504L33.7508 30.6504C32.1008 32.6004 29.5508 33.6504 27.0008 33.6504H22.5008C21.6008 33.6504 21.0008 33.0504 21.0008 32.1504C21.0008 31.2504 21.6008 30.6504 22.5008 30.6504H25.3508C27.7508 30.6504 30.0008 28.7004 30.0008 26.3004V26.1504C30.0008 25.4004 29.2508 24.6504 28.5008 24.6504H19.3508C13.9508 24.6504 9.60078 27.0504 7.20078 30.9504L3.15078 37.2504C2.85078 37.7004 2.85078 38.3004 3.15078 38.7504L7.65078 46.2504C7.80078 46.5504 8.25078 46.8504 8.55078 47.0004C8.70078 47.0004 8.70078 47.0004 8.85078 47.0004C9.15078 47.0004 9.45078 46.8504 9.75078 46.7004C15.4508 42.9504 22.0508 41.0004 28.8008 41.0004C33.7508 41.0004 38.2508 38.3004 40.6508 33.9504L44.7008 26.7504C45.0008 26.4504 45.0008 25.8504 44.8508 25.4004Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                    <path
                        d="M21 16.4004C21 12.6504 23.25 9.35039 26.4 7.70039C25.35 5.30039 22.95 3.65039 20.25 3.65039C16.5 3.65039 13.5 6.65039 13.5 10.4004C13.5 14.1504 16.5 17.1504 20.25 17.1504C20.55 17.1504 20.5 17.1504 21 17.1504C21 17.0004 21 16.7004 21 16.4004Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                </svg>
            );
        case "Welcome messages":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.9946 17.0616C22.395 15.2436 19.7278 14.7546 17.7238 16.4193C15.7197 18.084 15.4376 20.8673 17.0114 22.8363C17.9472 24.0071 20.2394 26.1065 21.9438 27.6163C22.6474 28.2395 22.9992 28.5511 23.4228 28.6775C23.785 28.7855 24.204 28.7855 24.5664 28.6775C24.9898 28.5511 25.3416 28.2395 26.0452 27.6163C27.7496 26.1065 30.0418 24.0071 30.9776 22.8363C32.5514 20.8673 32.3038 18.0665 30.2652 16.4193C28.2268 14.7721 25.594 15.2436 23.9946 17.0616Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6 14.4C6 12.1598 6 11.0397 6.43598 10.184C6.81946 9.43138 7.43138 8.81946 8.18404 8.43598C9.03968 8 10.1598 8 12.4 8H35.6C37.8402 8 38.9604 8 39.816 8.43598C40.5686 8.81946 41.1806 9.43138 41.564 10.184C42 11.0397 42 12.1598 42 14.4V40L35.3514 36.6756C34.8474 36.4236 34.5954 36.2976 34.3312 36.2088C34.0968 36.13 33.8554 36.073 33.6104 36.0386C33.3344 36 33.0526 36 32.4892 36H12.4C10.1598 36 9.03968 36 8.18404 35.564C7.43138 35.1806 6.81946 34.5686 6.43598 33.816C6 32.9604 6 31.8402 6 29.6V14.4Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "Customer engagement":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        d="M36 18V14.4C36 12.1598 36 11.0397 35.564 10.184C35.1806 9.43138 34.5686 8.81946 33.816 8.43598C32.9604 8 31.8402 8 29.6 8H14.4C12.1598 8 11.0397 8 10.184 8.43598C9.43138 8.81946 8.81946 9.43138 8.43598 10.184C8 11.0397 8 12.1598 8 14.4V36L16 32M40 40L35.6124 37.0748C35.013 36.6754 34.7134 36.4756 34.3892 36.334C34.1014 36.2084 33.8 36.1172 33.4908 36.062C33.1426 36 32.7824 36 32.0622 36H22.4C20.1598 36 19.0397 36 18.184 35.564C17.4314 35.1806 16.8195 34.5686 16.436 33.816C16 32.9604 16 31.8402 16 29.6V24.4C16 22.1598 16 21.0396 16.436 20.184C16.8195 19.4314 17.4314 18.8195 18.184 18.436C19.0397 18 20.1598 18 22.4 18H33.6C35.8402 18 36.9604 18 37.816 18.436C38.5686 18.8195 39.1806 19.4314 39.564 20.184C40 21.0396 40 22.1598 40 24.4V40Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "Payments & reminders":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                    <path
                        d="M24 32.6504H26C27.3334 32.6504 30 31.8504 30 28.6504C30 25.4504 27.3334 24.6504 26 24.6504H22C20.6666 24.6504 18 23.8504 18 20.6504C18 17.4504 20.6666 16.6504 22 16.6504H24M24 32.6504H18M24 32.6504V36.6504M24 16.6504H30M24 16.6504V12.6504M42 24.6504C42 34.5916 33.9412 42.6504 24 42.6504C14.0589 42.6504 6 34.5916 6 24.6504C6 14.7093 14.0589 6.65039 24 6.65039C33.9412 6.65039 42 14.7093 42 24.6504Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "Customer support & FAQs":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        d="M42 24H38C35.7909 24 34 25.7909 34 28V32C34 34.2091 35.7909 36 38 36C40.2091 36 42 34.2091 42 32V24ZM42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24M6 24V32C6 34.2091 7.79086 36 10 36C12.2091 36 14 34.2091 14 32V28C14 25.7909 12.2091 24 10 24H6Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M42 28V36C42 40 40.6667 42 38 42C35.3333 42 32 42 28 42" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            );
        case "Orders & updates":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path
                        d="M44 21V24C44 33.428 44 38.1422 41.071 41.071C38.1422 44 33.428 44 24 44C14.5719 44 9.85786 44 6.92894 41.071C4 38.1422 4 33.428 4 24C4 14.5719 4 9.85786 6.92894 6.92894C9.85786 4 14.5719 4 24 4H27"
                        stroke={strokeColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M38 16C41.3137 16 44 13.3137 44 10C44 6.68629 41.3137 4 38 4C34.6863 4 32 6.68629 32 10C32 13.3137 34.6863 16 38 16Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                    <path d="M14 28H32" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path d="M14 35H26" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                </svg>
            );
        case "Event invites":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path d="M30 10V16" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path d="M30 32V38" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path d="M30 22V26" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
                    <path
                        d="M8.88318 20.9114C7.58502 19.4676 5.93362 17.8694 6.15796 15.9407C6.7166 11.138 8.92042 10 15.296 10H32.704C39.0796 10 41.2834 11.138 41.842 15.9407C42.0664 17.8694 40.415 19.4676 39.1168 20.9114C38.4848 21.6144 38 22.6074 38 24C38 25.3926 38.4848 26.3856 39.1168 27.0886C40.415 28.5324 42.0664 30.1306 41.842 32.0592C41.2834 36.862 39.0796 38 32.704 38H15.296C8.92042 38 6.7166 36.862 6.15796 32.0592C5.93362 30.1306 7.58502 28.5324 8.88318 27.0886C9.5152 26.3856 9.99998 25.3926 9.99998 24C9.99998 22.6074 9.5152 21.6144 8.88318 20.9114Z"
                        stroke={strokeColor}
                        strokeWidth="2"
                    />
                </svg>
            );
        default:
            return null;
    }
};
